import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var _excluded = ["rewardCenterNotification", "render"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { TimedBonusKeys } from '../../api/Constants';
import NotificationContext from '../../context/NotificationContext';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import PushNotification from '../../lib/notifications/PushNotification';
import InboxMessagesProvider from '../InboxMessagesProvider';
import audio from '../../utils/audio';
import { FE_EVENTS, FE_ANIMATION } from '../../utils/featureFlags/constants';
import { ANIMATION_KEYS } from '../../components/Animations/constants';
import Utils from '../../utils';
import { sendEventsEvent } from '../../screens/Events/analytics/eventsLogger';
import { EVENTS_EVENT_TYPES, EVENTS_FEATURE_STATUS } from '../../screens/Events/constants';
import _rewardCenterMiddleware from '../../screens/RewardCenter/utils/middleware';
import TimestampManager from '../../utils/TimestampManager';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import NavigationConstants from '../LobbyOverlay/NavigationConstants';
import { MISSIONS_COUNTER } from '../../screens/Missions/constants';
import { handleNewActiveGameRoom } from '../../screens/Home/utils/helper';
import screens from '../../screens';
var BottomBar = /*#__PURE__*/function (_PureComponent) {
  function BottomBar() {
    var _this;
    _classCallCheck(this, BottomBar);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BottomBar, [].concat(_args));
    _this.state = {
      visible: true,
      openChest: false,
      videoAdsTimeUntilReset: 0,
      claimingBonus: false
    };
    // Variables de instancia para evitar re-renders
    _this.videoAdsTimer = null;
    _this.timerCheck = null;
    _this.isFirstRender = true;
    _this.lastNavState = null;
    _this.lastVideoAdsSeconds = null;
    _this.lastMessageCount = null;
    _this.handleNavStateChange = function (newNavState) {
      // Prevent unnecessary setState calls
      if (_this.lastNavState === newNavState) return;
      _this.lastNavState = newNavState;
      var shouldHide = [NavigationConstants.HIDE_BOTTOM, NavigationConstants.HIDE_BOTH].includes(newNavState);
      var newVisible = !shouldHide;
      if (_this.state.visible !== newVisible) {
        _this.setState({
          visible: newVisible
        });
      }
    };
    _this.checkTimerToReset = function (timeLeft) {
      clearTimeout(_this.timerCheck);
      _this.timerCheck = setTimeout(_this.timedBonusReady, timeLeft);
    };
    _this.checkTimedBonus = function (args) {
      if (!args) return;
      var tb = transformObjectResponseKeys(args, TimedBonusKeys);
      var timeRemaining = new Date(tb.TIME_LEFT).getTime() - Date.now();
      if (timeRemaining <= 0) {
        _this.setState(_objectSpread(_objectSpread({}, tb), {}, {
          openChest: true,
          TIME_LEFT: 0
        }));
      } else {
        _this.checkTimerToReset(timeRemaining);
        _this.setState(_objectSpread(_objectSpread({}, tb), {}, {
          openChest: false,
          TIME_LEFT: Date.now() + timeRemaining
        }));
      }
    };
    _this.timedBonusReady = function () {
      _this.setState({
        openChest: true,
        TIME_LEFT: 0
      });
    };
    _this.showModal = function (modalType) {
      audio.onClick();
      var _this$props = _this.props,
        sidebarState = _this$props.sidebarState,
        setSidebarState = _this$props.setSidebarState;
      setSidebarState(!sidebarState);
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType));
    };
    _this.setClaimingTimedBonus = function () {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.setState({
        claimingBonus: status
      });
      if (!Utils.isWebOrMobileWeb()) {
        _this.props.setClaimBonus(status);
      }
    };
    _this.timedBonusHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _animations$ANIMATION, _this$props$currentMi;
      var _useFeatureFlags, getFeatureConfig, animations, collectAnimEnabled, isMobile, isCollectMission, response, updateMissions, delay;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _useFeatureFlags = useFeatureFlags(), getFeatureConfig = _useFeatureFlags.getFeatureConfig;
            animations = getFeatureConfig(FE_ANIMATION);
            collectAnimEnabled = (_animations$ANIMATION = animations[ANIMATION_KEYS.COLLECT_BONUS]) === null || _animations$ANIMATION === void 0 ? void 0 : _animations$ANIMATION.enabled;
            isMobile = !Utils.isWebOrMobileWeb();
            audio.onClick();
            audio.playCoinSfx();
            isCollectMission = ((_this$props$currentMi = _this.props.currentMission) === null || _this$props$currentMi === void 0 ? void 0 : _this$props$currentMi.counterType) === MISSIONS_COUNTER.COLLECT_BONUS_X_TIMES;
            _context.prev = 7;
            _this.setClaimingTimedBonus(true);
            _context.next = 11;
            return _this.props.getTimedBonus();
          case 11:
            response = _context.sent;
            if (response) {
              if (isMobile) {
                PushNotification.scheduleTimedBonusNotification(response.originalTimeLeft);
              }
              _this.props.setTimedBonus(response);
              _this.checkTimedBonus(response);
              if (isCollectMission) {
                // Use requestIdleCallback for non-critical updates
                updateMissions = function updateMissions() {
                  _this.props.getBattlesAndMissions({
                    requestAssetsData: false
                  }, {
                    subscribe: false,
                    forceRefetch: true
                  });
                };
                if (window.requestIdleCallback) {
                  window.requestIdleCallback(updateMissions, {
                    timeout: 2000
                  });
                } else {
                  setTimeout(updateMissions, 2000);
                }
              }
            }
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](7);
            console.error('Error claiming timed bonus:', _context.t0);
          case 18:
            _context.prev = 18;
            delay = isMobile && collectAnimEnabled ? 1500 : 0;
            setTimeout(function () {
              return _this.setClaimingTimedBonus(false);
            }, delay);
            return _context.finish(18);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 15, 18, 22]]);
    }));
    _this.setVideoAdsTimeRemaining = function (seconds) {
      // Prevent duplicate updates
      if (_this.lastVideoAdsSeconds === seconds) return;
      _this.lastVideoAdsSeconds = seconds;
      var ms = seconds * 1000;
      _this.videoAdsTimer = TimestampManager.register(ms, _this.videoAdsReady);
      _this.setState({
        videoAdsTimeUntilReset: Date.now() + ms
      });
    };
    _this.videoAdsReady = function () {
      _this.setState({
        videoAdsTimeUntilReset: 0
      });
    };
    _this.getMessageCount = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var count;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return InboxMessagesProvider.getMessageCount();
          case 3:
            count = _context2.sent;
            // Only update if count actually changed
            if (_this.lastMessageCount !== count) {
              _this.lastMessageCount = count;
              _this.props.updateUnreadMessageCount(count);
            }
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.error('Error getting message count:', _context2.t0);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    _this.onInboxUpdateHandler = function () {
      _this.getMessageCount();
    };
    // Memoize events button calculation
    _this.shouldShowEventsButton = function () {
      var _events$data, _events$data2;
      var _useFeatureFlags2 = useFeatureFlags(),
        hasFeature = _useFeatureFlags2.hasFeature;
      var events = _this.props.events;
      return hasFeature(FE_EVENTS) && (events === null || events === void 0 || (_events$data = events.data) === null || _events$data === void 0 || (_events$data = _events$data.eventsFeatureState) === null || _events$data === void 0 ? void 0 : _events$data.eventsFeatureStatus) && (events === null || events === void 0 || (_events$data2 = events.data) === null || _events$data2 === void 0 || (_events$data2 = _events$data2.eventsFeatureState) === null || _events$data2 === void 0 ? void 0 : _events$data2.eventsFeatureStatus) !== EVENTS_FEATURE_STATUS.INACTIVE;
    };
    _this.handleOnClickVipAccess = function () {
      var _this$props2 = _this.props,
        isVIPRoom = _this$props2.isVIPRoom,
        canEnterVipRoom = _this$props2.canEnterVipRoom,
        navigation = _this$props2.navigation;
      if (isVIPRoom) handleNewActiveGameRoom(navigation, screens.Home);else if (!canEnterVipRoom) {
        _this.showModal(screens.VipAccessFlow);
      } else handleNewActiveGameRoom(navigation, screens.VIP);
    };
    return _this;
  }
  _inherits(BottomBar, _PureComponent);
  return _createClass(BottomBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
        timedBonus = _this$props3.timedBonus,
        navState = _this$props3.navState,
        videoAds = _this$props3.videoAds;

      // Initialize without causing re-render
      this.isFirstRender = false;

      // Initialize core functionality
      this.checkTimedBonus(timedBonus);
      this.handleNavStateChange(navState);

      // Start video ads timer if needed
      if ((videoAds === null || videoAds === void 0 ? void 0 : videoAds.secondsUntilReset) > 0) {
        this.setVideoAdsTimeRemaining(videoAds.secondsUntilReset);
      }

      // Subscribe to inbox updates
      InboxMessagesProvider.on(InboxMessagesProvider.EVENTKEY, this.onInboxUpdateHandler);
      this.getMessageCount();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$videoAds, _prevProps$videoAds;
      // Only update nav visibility when actually changed
      if (prevProps.navState !== this.props.navState) {
        this.handleNavStateChange(this.props.navState);
      }

      // Only update video ads timer when seconds actually change
      var newSeconds = (_this$props$videoAds = this.props.videoAds) === null || _this$props$videoAds === void 0 ? void 0 : _this$props$videoAds.secondsUntilReset;
      var oldSeconds = (_prevProps$videoAds = prevProps.videoAds) === null || _prevProps$videoAds === void 0 ? void 0 : _prevProps$videoAds.secondsUntilReset;
      if (newSeconds !== oldSeconds && newSeconds > 0) {
        this.setVideoAdsTimeRemaining(newSeconds);
      }

      // Notify parent only when visibility actually changes
      if (prevState.visible !== this.state.visible && this.props.sharedWillUpdate) {
        this.props.sharedWillUpdate(this.props, this.state);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Cleanup all resources
      TimestampManager.unregister(this.videoAdsTimer);
      clearTimeout(this.timerCheck);
      InboxMessagesProvider.off(InboxMessagesProvider.EVENTKEY, this.onInboxUpdateHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$videoAds2,
        _this2 = this;
      var _this$props4 = this.props,
        rewardCenterNotification = _this$props4.rewardCenterNotification,
        render = _this$props4.render,
        restProps = _objectWithoutProperties(_this$props4, _excluded);
      var showEventsButton = this.shouldShowEventsButton();

      // Send event only on actual first render
      if (this.isFirstRender && showEventsButton) {
        this.isFirstRender = false;
        sendEventsEvent(EVENTS_EVENT_TYPES.DISPLAY_EVENTS_ICON);
      }
      return render(_objectSpread(_objectSpread(_objectSpread({}, restProps), this.state), {}, {
        handleOnClickVipAccess: this.handleOnClickVipAccess,
        showModal: this.showModal,
        timedBonusHandle: this.timedBonusHandler,
        videoAds: {
          remaining: (_this$props$videoAds2 = this.props.videoAds) === null || _this$props$videoAds2 === void 0 ? void 0 : _this$props$videoAds2.remaining,
          timeUntilReset: this.state.videoAdsTimeUntilReset
        },
        showEventsButton: showEventsButton,
        rewardCenterNotification: rewardCenterNotification,
        rewardCenterMiddleware: function rewardCenterMiddleware() {
          return _rewardCenterMiddleware(_objectSpread(_objectSpread({}, _this2.props), {}, {
            notificationContext: _this2.context
          }));
        }
      }));
    }
  }]);
}(PureComponent);
BottomBar.contextType = NotificationContext;
export { BottomBar as default };